import { Panel } from "components/containers";
import React from "react";
import { useSelector } from "react-redux";
import TravelDetailsPanel from "./TravelDetailsPanel";
import { getAuthClaim } from "@redriver/cinnamon";
import useSkiSeasonDates from "modules/useSkiSeasonDates";

const TravelList = () => {
  const name = useSelector((s) => getAuthClaim(s, "userName"));
  const skiSeasonDates = useSkiSeasonDates();

  return (
    <div className="booking-details" style={{ margin: "0 0.5em" }}>
      <Panel border="left" className="booking-overview mid-blue">
        <div className="booking-header">
          <div>
            <span>Itinerary for {name}</span>
          </div>
          <div>
            <span>
              Ski Season {skiSeasonDates.start.format("YYYY")}/
              {skiSeasonDates.end.format("YYYY")}
            </span>
          </div>
        </div>
      </Panel>
      <TravelDetailsPanel />
    </div>
  );
};

export default TravelList;
